import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { DAMAGE_REPORT_STEP_RIGHT } from '../../store/actions/damage_report';
import front from '../../assets/images/damage_report/front@2x.png';
import Step from '../../components/damage_report/Step';

function FrontPage({ history }) {
  const { t } = useTranslation(['damage_report']);

  return (
    <div className="">
      <Step
        title={t('damage_report:front-step-title')}
        description={t('damage_report:front-step-description')}
        currentStep={'FRONT'}
        nextStep={DAMAGE_REPORT_STEP_RIGHT}
        image={front}
      />
    </div>
  );
}

export default withRouter(FrontPage);
